import { render, staticRenderFns } from "./CardLectureIcon.vue?vue&type=template&id=2a682f74&scoped=true&"
import script from "./CardLectureIcon.vue?vue&type=script&lang=js&"
export * from "./CardLectureIcon.vue?vue&type=script&lang=js&"
import style0 from "./CardLectureIcon.vue?vue&type=style&index=0&id=2a682f74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a682f74",
  null
  
)

export default component.exports